import { Form, Input, Checkbox, Col, Row } from 'antd'
import { FC, useEffect } from 'react'
import { MachineNames } from '../types'
import { ValidQuestionKeys } from '../../../../hooks/useGerateQuestions'

interface Props {
    setContentBasedItemsToReview: React.Dispatch<
        React.SetStateAction<ValidQuestionKeys[]>
    >
    setItemsToReview?: React.Dispatch<React.SetStateAction<ValidQuestionKeys[]>>
    userToggledQuestions?: Set<ValidQuestionKeys>
}
const DetailedDescription: FC<Props> = ({
    setContentBasedItemsToReview,
    setItemsToReview,
    userToggledQuestions,
}) => {
    // const [checked, setChecked] = useState(false)

    useEffect(() => {
        // Remove from content-based (disabled) list
        setContentBasedItemsToReview((prev) =>
            prev.filter((item) => item !== MachineNames.detailedDescription)
        )
        // Only auto-add if user hasn't manually toggled
        if (setItemsToReview) {
            setItemsToReview((prev) => {
                // If usertoggled, respectchoice
                if (
                    userToggledQuestions?.has(MachineNames.detailedDescription)
                ) {
                    return prev
                }
                // Otherwise, default to ON
                if (!prev.includes(MachineNames.detailedDescription)) {
                    return [...prev, MachineNames.detailedDescription]
                }
                return prev
            })
        }
    }, [setContentBasedItemsToReview, setItemsToReview, userToggledQuestions])

    return (
        <>
            <p>Detailed Description</p>
            <Form.Item
                name={['detailedDescription', 'describe-disclosure']}
                rules={[{}]}
                hasFeedback
            >
                <Input type="text" />
            </Form.Item>
            <Form.Item
                name={['detailedDescription', 'checked']}
                valuePropName="checked"
                style={{ marginBottom: '20px' }}
            >
                <Checkbox>add template language</Checkbox>
            </Form.Item>
            <Form.Item
                noStyle
                shouldUpdate={(prevValues, curValues) =>
                    prevValues.commonName?.notSet !==
                    curValues.commonName?.notSet
                }
            >
                {({ getFieldValue }) => {
                    const bool = getFieldValue([
                        'detailedDescription',
                        'checked',
                    ])
                    return bool ? (
                        <Row align="middle" gutter={[12, 0]}>
                            <Col span={14}>
                                <Form.Item
                                    name={['detailedDescription', 'described']}
                                    hasFeedback
                                    rules={[]}
                                >
                                    <Input placeholder="example" />
                                </Form.Item>
                            </Col>
                        </Row>
                    ) : null
                }}
            </Form.Item>
        </>
    )
}

export default DetailedDescription
